import '@hotmart/cosmos/dist/tooltip'

import type { TooltipProps } from './types'

const Tooltip = ({ content, children, className, position = 'bottom' }: TooltipProps) => {
  return (
    <hot-tooltip
      content={content}
      position={position}
      class={className}
      data-test='tooltip-element'>
      {children}
    </hot-tooltip>
  )
}

export default Tooltip
